import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { withStyleSheet } from 'hoc/styles';
import { config } from 'configuration';
import { ExternalLink } from 'components/ExternalLink';
import { Text } from 'components/Text';
import { styleSheet } from './stylesheet';

class NewDashboardBanner extends PureComponent {
    static propTypes = {
        styles: PropTypes.objectOf(PropTypes.any).isRequired
    };

    render() {
        const { styles } = this.props;
        // The whole strip is the link
        return (
            <ExternalLink className="print-hide" href={config.NEW_DASHBOARD_ENDPOINT} styles={styles.container}>
                <Text size={2} styles={styles.text}>
                    <Text size={2} span weight="medium">
                        The new Aiera dashboard is here.
                    </Text>{' '}
                    Sign in now, before the legacy dashboard is retired.{' '}
                    <Text size={2} span weight="medium" styles={styles.cta}>
                        Open the new dashboard &rarr;
                    </Text>
                </Text>
            </ExternalLink>
        );
    }
}

export const NewDashboardBannerUI = compose(withStyleSheet(styleSheet))(NewDashboardBanner);
